import React, { useState } from 'react';
import './Homepage.css';
import { IoHandLeftSharp } from 'react-icons/io5';
import Typewriter from 'typewriter-effect';
import graphicone from '../../../assets/graphic1.svg';
import { motion } from "framer-motion"
import { Link } from 'react-router-dom';

const Homepage = () => {

   const [isLoaded, setIsLoaded] = useState(false);
   const [isInView, setIsInView] = useState(false);

   const hiddenMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 30px, rgba(0,0,0,1) 30px, rgba(0,0,0,1) 30px)`;
   const visibleMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 0px, rgba(0,0,0,1) 30px)`;

    return (
        <div>
            <div className="p-4 sm:ml-20 lg:ml-48 md:ml-36 bg-gray-900">
               <div className="p-6">
                  <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 lg:mt-6 mt-4 items-center">
                     <div className='rounded text-left text-4xl leading-relaxed'>
                     <div className="flex items-center lg:whitespace-nowrap md:whitespace-nowrap sm:whitespace-warp">
                     <p className='text-gray-50'>Hi</p>
                     <span class="wave text-[#976DB2]"><IoHandLeftSharp></IoHandLeftSharp></span>
                     </div>
                     <p className='text-[#976DB2]'>I'm</p>
                     <p className='text-[#976DB2] text-3xl mb-2'>Mahabuba Akter Morsana</p>
                     <p className='text-gray-50 text-2xl'>IT Enthusiast and Solicitous in Design</p>
                     <span className='text-[#976DB2] text-2xl'>
                     <Typewriter
                     options={{
                        strings: ['Web Developer', 'Presentation Designer', 'Graphic Designer'],
                        autoStart: true,
                        loop: true,
                     }}
                     />
                     </span>
                     <Link to="/contact" type="button" class="text-gray-50 bg-gradient-to-r from-purple-500 via-purple-600 to-[#976DB2] hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-purple-300 shadow-md shadow-purple-400/40 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2">CONTACT ME</Link>
                     </div>
              <motion.div
              className="flex items-center justify-center rounded"
               initial={false}
               animate={
                  isLoaded && isInView
                     ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                     : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
               }
               transition={{ duration: 0.5, delay: 0.5 }}
               viewport={{ once: true }}
               onViewportEnter={() => setIsInView(true)}
               >
               <img className="sm:w-80 lg:w-full md:w-96" src={graphicone} alt="" onLoad={() => setIsLoaded(true)} />
               </motion.div>
                  </div>
               </div>
            </div>

        </div>
    );
};

export default Homepage;